<template>
  <app-breadcrumb v-if="breadcrumbItems.length > 0" :items="breadcrumbItems" />

  <div v-else class="flex gap-4">
    <app-skeleton-text class="bg-primary-100" />
    <app-skeleton-text class="bg-primary-100" />
    <app-skeleton-text class="bg-primary-100" />
  </div>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { BreadcrumbItem } from "~/shared/breadcrumb/breadcrumb.model";

const properties = defineProps<{
  course: CoursePageView;
}>();

const { t } = useI18n();

const breadcrumbItems = computed<BreadcrumbItem[]>(() => {
  const currentPageItem: BreadcrumbItem = {
    label: t("course.page.breadcrumb.course_label", {
      title: properties.course.subject || properties.course.title,
    }),
    tag: "h1",
  };

  const rootTag = properties.course.tags[0];

  if (!rootTag) return [];

  return [
    {
      label: t("course.page.breadcrumb.home_label"),
      to: "/",
    },
    {
      label: rootTag.label,
      to: {
        name: "catalog-index-categories-slug",
        params: { slug: rootTag.slug },
      },
    },
    currentPageItem,
  ];
});
</script>
